// jQuery is imported as webpack provided plugin - webpack.mix.js
import Base from "./components/Base";
import Header from "./components/Header";
import Package from "./components/Package";
import Helper from "./components/Helper";
import Hotel from "./components/Hotel";
import HotelCondition from "./components/HotelCondition";
import Lazyloading from "./components/Lazyloading";
import Map from "./components/map/Map";
import Filter from "./components/Filter";
import Search from "./components/Search";
import Session from "./components/Session";
import Sort from "./components/Sort";
import Url from "./components/Url";
import User from "./components/User";
import counter from "./components/Counter";
import Reservation from "./components/Reservation";
import Auth from "./components/Auth";
import PhoneInput from "./components/PhoneInput";
import Review from "./components/Review";
import Like from "./components/Like";
import cardCheck from "./components/cardCheck";
import ModalsWrapper from "./components/modals/ModalsWrapper";
import GalleriesWrapper from "./components/media/GalleriesWrapper";
import SearchWrapper from "./components/search/SearchWrapper";
import StepperWrapper from "./components/stepper/StepperWrapper";
import CounterWrapper from "./components/counters/CounterWrapper";
import Cart from "./components/cart/Cart";
import SortsWrapper from "./components/sorts/SortsWrapper";
import ReadMore from "./plugins/ReadMore";
import DocumentClickSubject from "./components/observers/DocumentClickSubject";
import WindowResizeSubject from "./components/observers/WindowResizeSubject";
import TimersInits from "./components/TimersInits";
import MapWrapper from "./components/map/MapWrapper";
import PaginationWithNumbers from "./components/pagination/PaginationWithNumbers";
import Country from "./components/Country";
import MoveIt from "./plugins/MoveIt";
import CookiesHelper from "./components/cookies/CookiesHelper";
import ImageSizes from "./plugins/ImageSizes";

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
window.$ = window.jQuery = require('jquery');

/**
 * Custom plugins
 */
let $readMore = new ReadMore();
let $moveIt = new MoveIt();

/**
 * Respo breakpoints
 */
window.mobileBreakpoint = 576;
window.bigMobileBreakpoint = 767;
window.tabletBreakpoint = 991;
window.mapBreakpoint = 1052;
window.laptopBreakpoint = 1199;

/**
 * Constants
 */
window.mobileScrollspyOffset = 8;
window.desktopScrollspyOffset = 20;

/**
 * Observers
 */
window.documentClickObserve = new DocumentClickSubject();
window.windowResizeObserve = new WindowResizeSubject();

/**
 * Project related components
 */
let $base = new Base(window.basic);

/**
 * TOP Priority
 */
window.urlClass = new Url(window.basic);

let $searchWrapper = new SearchWrapper(window.basic);

window.lazyloading = new Lazyloading(window.basic);

let $header = new Header(window.basic);
window.languageSelectBoxes = $header.languageSelectBoxes;

let $helpers = new Helper(window.basic);
window.loadMore = $helpers.loadMore;
window.refreshLoadMore = $helpers.refreshLoadMore;
window.toggleActiveParents = $helpers.toggleActiveParents;
window.copyToClipboard = $helpers.copyToClipboard;
window.clearInput = $helpers.clearInput;
window.showFilterModalRespo = $helpers.showFilterModalRespo;
window.redirectTo = $helpers.redirectTo;
window.hidePanel = $helpers.hidePanel;
window.scrollToElement = Helper.scrollToElement;
window.proccessPhoto = $helpers.proccessPhoto;
window.htmlOverflowY = $helpers.htmlOverflowY;

window.masonryFilter = new Filter(window.basic);
let $sort = new Sort(window.basic);

window.hotelClass = new Hotel(window.basic);
window.likeHotel = window.hotelClass.likeHotel;
window.toRoom = window.hotelClass.toRoom;
window.loadHotelInfo = window.hotelClass.loadHotelInfo;

/**
 * Medium priority
 */
let $map = new Map(window.basic);
window.initMap = $map.initMap;
window.updateMap = $map.updateMap;
window.loopData = $map.loopData;
window.addMapBind = $map.addMapBind;
window.initMapDependencies = $map.initMapDependencies;
window.toggleZoom = $map.toggleZoom;
window.stopZoom = $map.stopZoom;
window.customZoomControl = $map.customZoomControl;
window.fitBoundaries = $map.fitBoundaries;
window.clickMarker = $map.clickMarker;
window.hoverMarker = $map.hoverMarker;
window.zoomLocation = $map.zoomLocation;

let $hotelCondition = new HotelCondition(window.basic);

let $modalsWrapper = new ModalsWrapper(window.basic);
let $stepperWrapper = new StepperWrapper(window.basic);

let $sortsWrapper = new SortsWrapper(window.basic);
let $countersWrapper = new CounterWrapper(window.basic);

window.cart = new Cart();
window.mapWrapper = new MapWrapper();
window.reservation = new Reservation();
window.timersInit = new TimersInits();

/**
 * Lowest priority
 */
let $session = new Session(window.basic);
window.setSessions = $session.setSessions;

let $search = new Search(window.basic);
window.setsearchfield = $search.setsearchfield;
window.setsearchhotelfield = $search.setsearchhotelfield;
window.setSearchFieldRecentlyViewed = $search.setSearchFieldRecentlyViewed;

let $cardCheck = new cardCheck(window.basic);

let $package = new Package(window.basic);
window.removePackageCure = $package.removePackageCure;
window.showTreatmentAddModal = $package.showTreatmentAddModal;

let $counter = new counter(window.basic);
window.setMedicalTreatmentsPrice = $counter.setMedicalTreatmentsPrice;
window.SetQuantityToOne = $counter.SetQuantityToOne;

let $user = new User(window.basic);
window.editUserInfo = $user.editUserInfo;
window.cancelEditingUserInfo = $user.cancelEditingUserInfo;
window.saveEditingUserInfo = $user.saveEditingUserInfo;
window.showCloseModalImg = $user.showCloseModalImg;
window.cancelReservation = $user.cancelReservation;
window.sendVerificationEmail = $user.sendVerificationEmail;

let $auth = new Auth(window.basic);
window.recaptcha = $auth.recaptcha;
let $review = new Review(window.basic);
window.likeReview = $review.likeReview;
window.leaveReviewStepTwo = $review.leaveReviewStepTwo;
window.leaveReviewStepOne = $review.leaveReviewStepOne;
window.publishReview = $review.publishReview;
window.deleteReview = $review.deleteReview;

let $like = new Like(window.basic);
window.storeLikeIDBeforeLogin = $like.storeLikeIDBeforeLogin;
window.deleteLikeFromID = $like.deleteLikeFromID;

let $phone = new PhoneInput(window.basic);

let $galleriesWrapper = new GalleriesWrapper(window.basic);

let $paginationWithNumbers = new PaginationWithNumbers();

let $country = new Country();

let $cookiesHelper = new CookiesHelper();
window.acceptAllCookies = $cookiesHelper.acceptAllCookies;
window.acceptSelectedCookies = $cookiesHelper.acceptSelectedCookies;

window.imageSizes = new ImageSizes();
